// ════════════════════════════════════════════════════════════════
// GSA_CONSTANTS.js
// All data constants for the Guided Self-Assessment.
// Ported from prototype data.js into ES module named exports.
// ════════════════════════════════════════════════════════════════

var subDomain = "api";
if (window.location.host != "www.myptmyra.com" && window.location.host != "myptmyra.com" && window.location.host !== "www.startfreept.com" && window.location.host !== "startfreept.com" && window.location.host !== "virdiohealth.com" && window.location.host !== "www.virdiohealth.com") {
  subDomain = "uatapi";
}


export const SCORE_API_URL = "https://" + subDomain + ".virdiohealth.com/api/v1/assessment/analyze";
export const NEWS_POST = "https://" + subDomain + ".virdiohealth.com/api/v1/assessment/news";
export const SAVE_ACCESS_DATA = "https://" + subDomain + ".virdiohealth.com/api/v1/assessment/save-access-data";
export const SEND_ACCESS_MAIL = "https://" + subDomain + ".virdiohealth.com/api/v1/assessment/send-access-mail";
export const GET_ACCESS_DATA = `https://${subDomain}.virdiohealth.com/api/v1/assessment/access-data`;
export const CARE_SEARCH_PORVIDER = "https://" + subDomain + ".virdiohealth.com/api/v1/assessment/care-team-search-provider";
export const CARE_TEAM_SUBMISSION = "https://" + subDomain + ".virdiohealth.com/api/v1/assessment/care-team/submission";
export const CARE_TEAM_LOG = "https://" + subDomain + ".virdiohealth.com/api/v1/assessment/care-team/log";
export const CARE_TEAM_SAVE = "https://" + subDomain + ".virdiohealth.com/api/v1/assessment/care-team/save";
export const GENERATE_PLAN_URL = "https://" + subDomain + ".virdiohealth.com/api/v1/assessment/generate-plan";
export const ACCESS_ALIGNMENT_URL = `https://${subDomain}.virdiohealth.com/api/v1/access/alignment`;
export const GET_PROMO = "https://" + subDomain + ".virdiohealth.com/api/v1/cloud_dashboard/analytics/promo"
// https://uatapi.virdiohealth.com/api/v1/cloud_dashboard/analytics/promo
export const JOURNEY_API_URL = "https://" + subDomain + ".virdiohealth.com/api/v1/assessment/updateUserJourneyData";
export const SEND_CONTACT_MESSAGE = "https://" + subDomain + ".virdiohealth.com/api/v1/assessment/contact-message";
export const GET_STATE_LIST = `https://${subDomain}.virdiohealth.com/api/v1/cloud_therapist/getStateList`
export const USER_REGISTER = `https://${subDomain}.virdiohealth.com/api/v1/user/register`
export const RESEND_OTP = `https://${subDomain}.virdiohealth.com/api/v1/user/resendOtp`
export const SET_NEW_EMAIL = `https://${subDomain}.virdiohealth.com/api/v1/user/setNewEmail`
export const VERIFY_OTP = `https://${subDomain}.virdiohealth.com/api/v1/user/verifyOtp`
export const REGISTER_DATA_URL = `https://${subDomain}.virdiohealth.com/api/v1/user/register_data`
export const PAYMENT = `https://${subDomain}.virdiohealth.com/api/v1/payment/pay`
export const PAYMENT_CONFIRM = `https://${subDomain}.virdiohealth.com/api/v1/payment/confirmPayment`
export const VALIDATE_CUPON = `https://${subDomain}.virdiohealth.com/api/v1/payment/validate-coupon`
export const GET_QUESTIONNAIRE = `https://${subDomain}.virdiohealth.com/api/v1/cloud_questionnaires/get-questionnaire`
export const GET_QUESTIONNAIRE_PUBLIC = `https://${subDomain}.virdiohealth.com/api/v1/cloud_questionnaires/get-questionnaire-public`
export const SUBMIT_QUESTIONNAIRE = `https://${subDomain}.virdiohealth.com/api/v1/cloud_questionnaires/submit-questionnaire`
export const SaveQuestionnaireTarget = "https://" + subDomain + ".virdiohealth.com/api/v1/assessment/save-questionnaire-target";

export const STRIPE_PUBLISHABLE_KEY_LIVE = "pk_live_51Rss3IH1nrhmxiRiQaRXXNvXY4n0lWbgAI6PLvSVjvWLdL4CgyozrYN8o0UA0N0uY7nxbTuY9WtyV34Xzy0zDm6900H5PGsUae"
export const STRIPE_PUBLISHABLE_KEY_TEST = "pk_test_51S3wiaIExR45TTcWG4JyD3grVTDEIR2c5Nf3P7RxDFlsMRwdKz9H1YPtqPoZ8QBUf33x9P8IRMvF1VgQeqeafy0d009lyvfwKJ";

// ── Asset URLs ────────────────────────────────────────────────
export const LOGO = "https://virdiodev.s3.us-east-2.amazonaws.com/sampleVideo/startfreept_logo.svg";
export const SKELETON = "https://virdiodev.s3.us-east-2.amazonaws.com/sampleVideo/VH-Bodyoutline.png";
export const PLACEHOLDER_VIDEO = "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/PLACEHOLDER.mp4";
export const HOME_VIDEO_2 = "https://virdiodev.s3.us-east-2.amazonaws.com/sampleVideo/HeroVideo-StartFreePT-v2.0.mp4";

// ════════════════════════════════════════════════════════════════
// PROBLEM AREAS & CLINICAL PATHS
// LBP = unique 2-step CPG branching (leg pain? → then CPG)
// HKT = unified structure: cpgQuestion → subtypeQuestions → tests
// ════════════════════════════════════════════════════════════════
/** Same “Coming Soon” body areas as GSA v1 problem area screen. */
export const COMING_SOON_OPTIONS = ["Shoulder", "Elbow", "Ankle", "Wrist", "Neck", "Flexibility"];
export const CLINICAL_PATHS = {
  LBP: {
    name: "Lower Back",
    zones: { left: ['Lower Back', 'Buttock', 'Thigh', 'Lower Leg'], right: ['Lower Back', 'Buttock', 'Thigh', 'Lower Leg'] },
  },
  HIP: {
    name: "Hip",
    zones: { left: ['Lower Back', 'Buttock', 'Front/Groin', 'Side Hip', 'Thigh', 'Knee'], right: ['Lower Back', 'Buttock', 'Front/Groin', 'Side Hip', 'Thigh', 'Knee'] },
    overrideTarget: 'PELVIC_CONTROL_IMPAIRMENT',
    cpgQuestion: {
      prompt: "Which of these best describes your primary hip complaint?",
      options: [
        {
          id: "hip-cpg-mobility",
          label: "Stiff or tight",
          info: "Hard to put on socks, get out of low chairs, sit cross-legged. Movement-pattern, not weakness.",
          value: "HIP_MOBILITY_DEFICITS",
          cpgForBackend: "Hip Pain with Mobility Deficits",
          routesTo: "subtypeQuestion",
          subtypeQuestionIndex: 0,
        },
        {
          id: "hip-cpg-power",
          label: "Weak or unsteady",
          info: "Often dismissed as bursitis for years. Targeted exercise outperforms cortisone injections at one year for this.",
          value: "HIP_MUSCLE_POWER_DEFICITS",
          cpgForBackend: "Hip Pain with Muscle Power Deficits",
          routesTo: "subtypeQuestion",
          subtypeQuestionIndex: 1,
        },
        {
          id: "hip-cpg-motor",
          label: "Pinching or catching",
          info: "Up to 60% of these are misdiagnosed at first because imaging often looks normal. The pattern itself is well-recognized.",
          value: "HIP_IMPAIRED_MOTOR_CONTROL",
          cpgForBackend: "Hip Pain with Impaired Motor Control",
          routesTo: "direct",
          directSubtype: "PELVIC_CONTROL_IMPAIRMENT",
        },
      ],
    },
    subtypeQuestions: [
      {
        prompt: "Where do you feel it the most?",
        options: [
          { id: "hip-sub-lateral", label: "On the side of my hip, especially when lying on that side or walking.", info: "Pillows under the leg at night, picking which side to sleep on, taking the elevator more. Sound familiar?", value: "HIP_ABDUCTION_EXTERNAL_ROTATION_CONTROL_DEFICIT" },
          { id: "hip-sub-anterior", label: "In the front of my hip or groin, especially when extending my leg behind me.", info: "Worse with deep chairs, deep squats, getting out of the car. The front of the joint complaining about positions.", value: "ANTERIOR_CHAIN_MOBILITY_DEFICIT" },
          { id: "hip-sub-posterior", label: "In my buttock or the back of my hip, especially when bringing my knee towards my chest.", info: "Stretching the hamstring sometimes makes it worse instead of better, and that's not your fault.", value: "POSTERIOR_CHAIN_MOBILITY_DEFICIT" },
          { id: "hip-sub-rotational", label: "In my groin or the crease where my leg meets my body, especially with twisting or crossing my legs.", info: "Turning at the kitchen counter, planting your foot to change direction, twisting to load the dishwasher.", value: "POSTERIOR_CHAIN_MOBILITY_DEFICIT" },
          { id: "hip-sub-neuro", label: "A specific, deep pain in my buttock, sometimes with tingling down my leg.", info: "Builds with sitting, often hitting hard around the 20 to 30 minute mark. That specific.", value: "NEUROMUSCULAR_MOBILITY_DEFICIT" },
          { id: "hip-sub-global", label: "A general, deep ache and stiffness all around the joint, worse in the morning.", info: "Stiff in the morning, eases as you start moving, returns through the day, and you've probably reorganized more than you realize.", value: "POSTERIOR_CHAIN_MOBILITY_DEFICIT" },
        ],
      },
      {
        prompt: "Which is most difficult?",
        options: [
          { id: "hip-sub-adductor", label: "Moving my legs apart", info: "When you try to squeeze your heels together hard, there's weakness too, not just pain.", value: "ADDUCTOR_OVERLOAD_CONTROL_DEFICIT" },
          { id: "hip-sub-abduction", label: "Standing on one leg or stairs", info: "A sense of the hip dropping or dipping when you walk. This is mostly fixable with strength.", value: "HIP_ABDUCTION_EXTERNAL_ROTATION_CONTROL_DEFICIT" },
        ],
      },
    ],
  },
  THIGH: {
    name: "Thigh",
    zones: { left: ['Back', 'Buttock', 'Hip', 'Back Thigh', 'Front Thigh', 'Inner Thigh', 'Outer Thigh', 'Knee'], right: ['Back', 'Buttock', 'Hip', 'Back Thigh', 'Front Thigh', 'Inner Thigh', 'Outer Thigh', 'Knee'] },
    overrideTarget: 'HAMSTRING_LOADING_LENGTHENING_DEFICIT',
    cpgQuestion: {
      prompt: "Which of these best describes the feeling in your thigh?",
      options: [
        {
          id: "thigh-cpg-muscular",
          label: "A muscular ache or pull",
          info: "Maybe a pop moment you remember, or a slow ache from training. The body suddenly not cooperating.",
          value: "THIGH_MUSCULAR_ORIGIN",
          cpgForBackend: "Thigh Pain with Muscular Origin",
          routesTo: "subtypeQuestion",
          subtypeQuestionIndex: 0,
        },
        {
          id: "thigh-cpg-neural",
          label: "Burning or tingling",
          info: "Often called the elusive diagnosis. Many clinicians do not recognize this nerve-compression pattern.",
          value: "THIGH_NEURAL_INVOLVEMENT",
          cpgForBackend: "Thigh Pain with Muscular Origin",
          routesTo: "direct",
          directSubtype: "HAMSTRING_LOADING_LENGTHENING_DEFICIT",
        },
        {
          id: "thigh-cpg-referred",
          label: "A deep ache from somewhere else",
          info: "About 20% of people first told they had a lumbar issue actually had hip-related pain referring down.",
          value: "THIGH_REFERRED_SYMPTOMS",
          cpgForBackend: "Thigh Pain with Muscular Origin",
          routesTo: "direct",
          directSubtype: "HAMSTRING_LOADING_LENGTHENING_DEFICIT",
        },
      ],
    },
    subtypeQuestions: [
      {
        prompt: "Where do you feel it the most?",
        options: [
          { id: "thigh-sub-anterior", label: "Front of my thigh", info: "Either a sharp moment you remember, or a slower loading ache with stairs and standing up. Both count.", value: "QUADRICEPS_LOADING_IMPACT_INTOLERANCE" },
          { id: "thigh-sub-medial", label: "Inner thigh or groin", info: "Sometimes confused with a hernia, hip flexor strain, or pelvic causes, but it has its own specific signature.", value: "ADDUCTOR_OVERLOAD_CONTROL_DEFICIT" },
          { id: "thigh-sub-posterior", label: "Back of my thigh", info: "Hamstring strain isn't only an athlete's injury. The peak count happens in adults 60 to 64.", value: "HAMSTRING_LOADING_LENGTHENING_DEFICIT" },
          { id: "thigh-sub-lateral", label: "Outer side of my thigh", info: "Outer-thigh pain has a few possible sources, the side muscles, the hip chain, or load from nearby joints.", value: "ITB_FRICTION_SYNDROME" },
        ],
      },
    ],
  },
  KNEE: {
    name: "Knee",
    zones: { left: ['Back', 'Buttock', 'Hip', 'Thigh', 'Front Knee', 'Back Knee', 'Inner Knee', 'Outer Knee'], right: ['Back', 'Buttock', 'Hip', 'Thigh', 'Front Knee', 'Back Knee', 'Inner Knee', 'Outer Knee'] },
    overrideTarget: 'LIMITED_KNEE_EXTENSION_FLEXION_MOBILITY',
    cpgQuestion: {
      prompt: "Which of these best describes where you feel your knee pain?",
      options: [
        {
          id: "knee-cpg-pfp",
          label: "Around or behind the kneecap",
          info: "If you've been told just rest, it'll pass, that advice does not match the evidence for this pattern.",
          value: "KNEE_PATELLOFEMORAL",
          cpgForBackend: "Patellofemoral Pain (PFP)",
          routesTo: "subtypeQuestion",
          subtypeQuestionIndex: 0,
        },
        {
          id: "knee-cpg-mobility",
          label: "Stiff, blocked, or unsteady",
          info: "When the joint feels untrustworthy, slipping, locking, or just not steady, even between bad moments.",
          value: "KNEE_MOBILITY_STABILITY",
          cpgForBackend: "Knee Pain with Mobility/Stability Deficits",
          routesTo: "subtypeQuestion",
          subtypeQuestionIndex: 1,
        },
        {
          id: "knee-cpg-lateral",
          label: "On the outer side",
          info: "Most cases recover within about 6 weeks, usually through hip strengthening and modified loading.",
          value: "KNEE_LATERAL",
          cpgForBackend: "Knee Pain with Lateral Symptoms",
          routesTo: "direct",
          directSubtype: "ITB_FRICTION_SYNDROME",
        },
        {
          id: "knee-cpg-posterior",
          label: "Behind the knee",
          info: "Has multiple possible sources. Most respond to conservative care.",
          value: "KNEE_POSTERIOR",
          cpgForBackend: "Knee Pain with Posterior Symptoms",
          routesTo: "direct",
          directSubtype: "HAMSTRING_LOADING_LENGTHENING_DEFICIT",
        },
        {
          id: "knee-cpg-medial",
          label: "On the inner side",
          info: "Multiple landmark trials show exercise therapy matches arthroscopic surgery for degenerative tears.",
          value: "KNEE_MEDIAL",
          cpgForBackend: "Knee Pain with Medial Symptoms",
          routesTo: "direct",
          directSubtype: "LIMITED_KNEE_EXTENSION_FLEXION_MOBILITY",
        },
      ],
    },
    subtypeQuestions: [
      {
        prompt: "When do you notice it most?",
        options: [
          { id: "knee-sub-valgus", label: "Squatting or going downstairs", info: "If you've started taking stairs slower or holding the rail more, that itself is the pattern.", value: "KNEE_VALGUS_COLLAPSE" },
          { id: "knee-sub-maltrack", label: "After sitting a while", info: "This pattern has a name. Clinicians often call it the movie sign. That alone tells you it's recognized.", value: "PATELLOFEMORAL_PAIN_WITH_MALTRACKING" },
          { id: "knee-sub-tendon", label: "Jumping or running", info: "Often called runner's knee, but you do not have to run to get it.", value: "QUADRICEPS_LOADING_IMPACT_INTOLERANCE" },
        ],
      },
      {
        prompt: "Which describes your knee best?",
        options: [
          { id: "knee-sub-stiff", label: "Stiff and limited", info: "Yoyos through the day, better with movement, worse after rest. That fluctuation is the pattern.", value: "LIMITED_KNEE_EXTENSION_FLEXION_MOBILITY" },
          { id: "knee-sub-unstable", label: "Unsteady or giving way", info: "27% of people feel this without their knee ever actually buckling. More common than buckling itself.", value: "TIBIAL_TRANSLATION_INSTABILITY" },
        ],
      },
    ],
  },
};


// ════════════════════════════════════════════════════════════════
// PAIN LOCATION COORDINATES (% of image: [x, y, width, height])
// Left-side defined; right side auto-mirrored.
// ════════════════════════════════════════════════════════════════

export const ZONE_COORDS = {
  LBP: {
    left: {
      'Lower Back': [36.5, 33.5, 12.0, 8.0],
      'Buttock': [36.1, 45.5, 12.8, 7.8],
      'Thigh': [36.8, 57.0, 11.4, 12.0],
      'Lower Leg': [37.5, 74.5, 10.0, 14.0],
    }
  },
  HIP: {
    left: {
      'Lower Back': [36.8, 38.0, 12.0, 6.2],
      'Buttock': [37.2, 46.8, 12.7, 3.8],
      'Front/Groin': [37.2, 51.1, 11.3, 4.0],
      'Side Hip': [31.0, 46.8, 5.5, 6.5],
      'Thigh': [37.2, 58.8, 10.5, 10.0],
      'Knee': [37.5, 69.5, 10.0, 5.0],
    }
  },
  THIGH: {
    left: {
      'Back': [35.8, 36.5, 13.3, 6.5],
      'Buttock': [36.5, 47.0, 12.0, 7.0],
      'Hip': [31.0, 45.0, 5.0, 9.0],
      'Back Thigh': [37.2, 56.0, 10.5, 5.0],
      'Front Thigh': [37.2, 61.0, 10.5, 5.0],
      'Inner Thigh': [47.7, 56.0, 4.2, 10.0],
      'Outer Thigh': [31.6, 56.0, 4.2, 10.0],
      'Knee': [37.5, 69.5, 10.0, 5.0],
    }
  },
  KNEE: {
    left: {
      'Back': [36.7, 36.5, 11.6, 6.5],
      'Buttock': [36.5, 47.0, 12.0, 7.0],
      'Hip': [31.0, 45.0, 5.0, 9.0],
      'Thigh': [37.2, 57.0, 10.5, 11.0],
      'Front Knee': [37.5, 69.5, 10.0, 2.5],
      'Back Knee': [37.5, 72.0, 10.0, 2.5],
      'Inner Knee': [47.5, 69.5, 3.5, 5.0],
      'Outer Knee': [32.5, 69.5, 3.5, 5.0],
    }
  },
};

// Build mirrored right-side coordinates for each body area
export function mirrorCoords(leftCoords) {
  const right = {};
  Object.entries(leftCoords).forEach(([k, v]) => {
    right[k] = [Math.round((100 - v[0] - v[2]) * 100) / 100, v[1], v[2], v[3]];
  });
  return right;
}

// Initialize right-side coordinates
Object.keys(ZONE_COORDS).forEach(area => {
  ZONE_COORDS[area].right = mirrorCoords(ZONE_COORDS[area].left);
});

// ── Zone Highlight Classification ──
export const FULL_ZONES = ['Lower Back', 'Buttock', 'Thigh', 'Lower Leg', 'Knee', 'Back'];
export const SPLIT_ZONES = ['Front/Groin', 'Back Thigh', 'Front Thigh', 'Front Knee', 'Back Knee'];
export const EDGE_ZONES = ['Side Hip', 'Hip', 'Inner Thigh', 'Outer Thigh', 'Inner Knee', 'Outer Knee'];

export function hlType(z) {
  return EDGE_ZONES.includes(z) ? 'edge' : SPLIT_ZONES.includes(z) ? 'split' : 'full';
}
export function splitHalf(z) {
  return z.startsWith('Back') ? 'upper' : 'lower';
}
export function edgeSide(z) {
  if (z === 'Side Hip' || z === 'Hip' || z.startsWith('Outer')) return 'outer';
  return 'inner';
}


// ════════════════════════════════════════════════════════════════
// SAFETY SCREEN — All Body Areas
// LBP: 3-path model (STOP, FUNCTIONAL_GATE with follow-ups)
// HKT: simple referral model (any checked = referral/stop)
// ════════════════════════════════════════════════════════════════

export const SAFETY_QUESTIONS = {
  LBP: true,
  HIP: true,
  THIGH: true,
  KNEE: true,
};

// ════════════════════════════════════════════════════════════════
// LBP-SPECIFIC CPG & SUBTYPE LOGIC
// LBP uses a unique 2-step branching flow unlike HKT
// ════════════════════════════════════════════════════════════════

export const CPG_OPTIONS_LEG = [
  {
    id: "cpg-radiating",
    label: "Sharp and shooting",
    value: "LBP with Radiating Pain (Radiculopathy)",
    info: "A narrow line traveling down the leg, like a wire running through it.",
  },
  {
    id: "cpg-referred",
    label: "Dull and spread out",
    value: "LBP with Related (Referred) Lower Extremity Pain",
    info: "A deep ache spread through the leg, hard to point to one spot.",
  },
];

export const CPG_OPTIONS_BACK = [
  {
    id: "cpg-mobility",
    label: "Stiff and restricted",
    value: "LBP with Mobility Deficits",
    info: "A deep ache and restricted movement, about half of all back-only pain.",
  },
  {
    id: "cpg-coordination",
    label: "Unstable or weak",
    value: "LBP with Movement Coordination Impairments",
    info: "Like the back might give out, weakness more than stiffness.",
  },
];

export const Q1_OPTIONS = [
  { id: "q1a", value: "a", label: "It hurts when I sit", info: "Probably already shifting in your chair, getting up more, dreading long meetings. That's the pattern." },
  { id: "q1b", value: "b", label: "It hurts to stand for long", info: "The kind where leaning forward on a counter, cart, or chair feels like the only thing that helps." },
  { id: "q1e", value: "e", label: "It hurts to twist", info: "Rolling over in bed, getting in or out of the car, looking over your shoulder backing up." },
  { id: "q1c", value: "c", label: "It hurts no matter what", info: "When no position consistently helps, you're carrying something harder than the others, not failing at it." },
  { id: "q1d", value: "d", label: "Honestly, I'm not sure", info: "Pain at this depth doesn't always follow neat rules, and noticing that is its own kind of clarity." },
];

export const Q2_MAP = {
  a: { title: "Does standing up straight or gently arching your back help?", name: "q2a" },
  b: { title: "Does sitting down help?", name: "q2b" },
  e: { title: "Does avoiding twisting help?", name: "q2e" },
  c: { title: "Does moving around or changing position help?", name: "q3" },
  d: { title: "Does moving around or changing position help?", name: "q3" },
};

export function getSubtype(q1, q2) {
  if (q1 === "a") return q2 === "yes" ? "FLEXION_INTOLERANT" : "NEUTRAL_SENSITIVE";
  if (q1 === "b") return q2 === "yes" ? "EXTENSION_INTOLERANT" : "NEUTRAL_SENSITIVE";
  if (q1 === "e") return q2 === "yes" ? "ROTATIONAL_INTOLERANT" : "NEUTRAL_SENSITIVE";
  return "NEUTRAL_SENSITIVE";
}

export function cpgToSubtype(cpgValue) {
  if (!cpgValue) return null;
  if (cpgValue.includes("Mobility Deficits")) return "LIMITED_LUMBAR_MOBILITY";
  if (cpgValue.includes("Movement Coordination")) return "NEUTRAL_SENSITIVE";
  return null;
}

export const LEG_ZONES = ["left:Thigh", "right:Thigh", "left:Lower Leg", "right:Lower Leg"];

export function hasLegPain(zones) {
  return zones.some(z => LEG_ZONES.includes(z));
}

export const ZONE_ECHO_PHRASE = {
  "Lower Back": "lower back",
  Buttock: "buttock",
  Thigh: "thigh",
  "Lower Leg": "lower leg",
  "Front/Groin": "front and groin",
  "Side Hip": "side of the hip",
  Knee: "knee",
  Back: "back",
  Hip: "hip",
  "Back Thigh": "back of the thigh",
  "Front Thigh": "front of the thigh",
  "Inner Thigh": "inner thigh",
  "Outer Thigh": "outer thigh",
  "Front Knee": "front of the knee",
  "Back Knee": "back of the knee",
  "Inner Knee": "inner knee",
  "Outer Knee": "outer knee",
};

export function joinWithOxford(items) {
  if (!items || items.length === 0) return "";
  if (items.length === 1) return items[0];
  if (items.length === 2) return items[0] + " and " + items[1];
  return items.slice(0, -1).join(", ") + ", and " + items[items.length - 1];
}

export function buildPinpointEcho(selections) {
  const byZone = {};
  (selections || []).forEach((s) => {
    if (!byZone[s.zone]) byZone[s.zone] = new Set();
    byZone[s.zone].add(s.side);
  });

  const bilateral = [];
  const leftOnly = [];
  const rightOnly = [];

  Object.keys(byZone).forEach((zone) => {
    const sides = byZone[zone];
    const phrase = ZONE_ECHO_PHRASE[zone] || zone.toLowerCase();
    if (sides.has("left") && sides.has("right")) bilateral.push(phrase);
    else if (sides.has("left")) leftOnly.push(phrase);
    else rightOnly.push(phrase);
  });

  const parts = [];
  if (bilateral.length > 0) parts.push("my " + joinWithOxford(bilateral) + " on both sides");
  if (leftOnly.length > 0) parts.push("my " + joinWithOxford(leftOnly) + " on the left");
  if (rightOnly.length > 0) parts.push("my " + joinWithOxford(rightOnly) + " on the right");
  return parts.length ? "I feel it in " + joinWithOxford(parts) + "." : "";
}

export function getPinpointValidationKey(area, selections = []) {
  const distinctZones = new Set((selections || []).map((s) => s.zone));
  const zoneCount = distinctZones.size;

  if (area === "LBP") {
    const hasNonBackZone = selections.some((s) => s.zone !== "Lower Back");
    return hasNonBackZone ? "LBP_LEG" : "LBP_BACK_ONLY";
  }

  if (area === "HIP") {
    const hasAnterior = distinctZones.has("Front/Groin");
    if (zoneCount === 1) return "HIP_SINGLE";
    return hasAnterior ? "HIP_MULTI" : "HIP_SINGLE";
  }

  if (area === "KNEE") {
    return zoneCount === 1 ? "KNEE_SINGLE" : "KNEE_MULTI";
  }

  if (area === "THIGH") {
    const thighZones = ["Back Thigh", "Front Thigh", "Inner Thigh", "Outer Thigh"];
    const proximalZones = ["Back", "Buttock"];
    const hasThigh = selections.some((s) => thighZones.includes(s.zone));
    const hasProximal = selections.some((s) => proximalZones.includes(s.zone));
    const onlyThighZones = selections.every((s) => thighZones.includes(s.zone));

    if (hasThigh && hasProximal) return "THIGH_B1";
    if (onlyThighZones && hasThigh) return "THIGH_B2";
    return "THIGH_A";
  }

  return null;
}

export const HIP_MOB_Q1_ZONE_TO_OPTION = {
  "Side Hip": "hip-sub-lateral",
  "Front/Groin": "hip-sub-anterior",
  Buttock: "hip-sub-posterior",
};

export const THIGH_Q1_ZONE_TO_OPTION = {
  "Front Thigh": "thigh-sub-anterior",
  "Inner Thigh": "thigh-sub-medial",
  "Back Thigh": "thigh-sub-posterior",
  "Outer Thigh": "thigh-sub-lateral",
};

export function planSubtypeQ1Decision(pinpointSelections, zoneToOption, options) {
  if (!pinpointSelections || pinpointSelections.length === 0) {
    return { mode: "plain", referencePhrase: null };
  }

  const inSet = new Set();
  pinpointSelections.forEach((s) => {
    if (zoneToOption[s.zone]) inSet.add(s.zone);
  });

  const hits = Array.from(inSet);
  if (hits.length === 0) return { mode: "plain", referencePhrase: null };

  if (hits.length === 1) {
    const optionId = zoneToOption[hits[0]];
    const opt = options.find((o) => o.id === optionId);
    return { mode: "skip", optionId, option: opt };
  }

  const phrases = hits.map((z) => "your " + (ZONE_ECHO_PHRASE[z] || z.toLowerCase()));
  return { mode: "reference", referencePhrase: joinWithOxford(phrases) };
}



// ════════════════════════════════════════════════════════════════
// MOVEMENT Check MAPS — All Body Areas
// Flat lookup by subtype. Shared subtypes use the same test.
// ════════════════════════════════════════════════════════════════

export const TEST_MAP = {
  // LBP
  FLEXION_INTOLERANT: { name: "Standing Lumbar Extension", video: "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/StandingLumbarExtensionROMv1.0.mp4" },
  EXTENSION_INTOLERANT: { name: "Seated Single Knee to Chest", video: "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/SeatedSingleKneeToChestv1.0.mp4" },
  NEUTRAL_SENSITIVE: { name: "Seated Trunk Rotation", video: "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/SeatedTrunkRotationv1.0.mp4" },
  LIMITED_LUMBAR_MOBILITY: { name: "Side to Side Bend", video: "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/SideToSideBendv1.0.mp4" },
  ROTATIONAL_INTOLERANT: { name: "Standing Lumbar Extension", video: "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/StandingLumbarExtensionROMv1.0.mp4" },
  // HIP
  ANTERIOR_CHAIN_MOBILITY_DEFICIT: { name: "Standing Hip Flexor Stretch", video: PLACEHOLDER_VIDEO },
  POSTERIOR_CHAIN_MOBILITY_DEFICIT: { name: "Seated Glute Stretch", video: PLACEHOLDER_VIDEO },
  NEUROMUSCULAR_MOBILITY_DEFICIT: { name: "Seated Glute Stretch", video: PLACEHOLDER_VIDEO },
  ADDUCTOR_OVERLOAD_CONTROL_DEFICIT: { name: "Seated Hip Hinge", video: PLACEHOLDER_VIDEO },
  HIP_ABDUCTION_EXTERNAL_ROTATION_CONTROL_DEFICIT: { name: "Seated Hip Abduction", video: PLACEHOLDER_VIDEO },
  PELVIC_CONTROL_IMPAIRMENT: { name: "Seated Hip Hinge", video: PLACEHOLDER_VIDEO },
  // THIGH
  QUADRICEPS_LOADING_IMPACT_INTOLERANCE: { name: "Seated Isometric Knee Extension", video: PLACEHOLDER_VIDEO },
  HAMSTRING_LOADING_LENGTHENING_DEFICIT: { name: "Toe Touch", video: PLACEHOLDER_VIDEO },
  ITB_FRICTION_SYNDROME: { name: "Standing ITB Stretch - Side Bend", video: PLACEHOLDER_VIDEO },
  // KNEE (subtypes not already defined above)
  KNEE_VALGUS_COLLAPSE: { name: "Seated Hip Abduction", video: PLACEHOLDER_VIDEO },
  PATELLOFEMORAL_PAIN_WITH_MALTRACKING: { name: "Seated Isometric Knee Extension", video: PLACEHOLDER_VIDEO },
  LIMITED_KNEE_EXTENSION_FLEXION_MOBILITY: { name: "Seated Isometric Knee Extension", video: PLACEHOLDER_VIDEO },
  TIBIAL_TRANSLATION_INSTABILITY: { name: "Seated Isometric Knee Extension", video: PLACEHOLDER_VIDEO },
};


export function resolveLongTermBeatKey(data = {}) {
  const area = data.problemArea;

  if (area === "LBP") {
    return data.isLegPain ? "LBP.leg" : "LBP.back";
  }

  if (area === "HIP") {
    if (data.cpgCategory === "HIP_MUSCLE_POWER_DEFICITS" || data.cpgValue === "Hip Pain with Muscle Power Deficits") return "HIP.power";
    if (data.cpgCategory === "HIP_IMPAIRED_MOTOR_CONTROL" || data.cpgValue === "Hip Pain with Impaired Motor Control") return "HIP.motor";
    return "HIP.mobility";
  }

  if (area === "THIGH") return "THIGH.default";

  if (area === "KNEE") {
    if (data.cpgCategory === "KNEE_MOBILITY_STABILITY") return "KNEE.stability";
    if (data.cpgCategory === "KNEE_POSTERIOR") return "KNEE.posterior";
    if (data.cpgCategory === "KNEE_MEDIAL") return "KNEE.medial";
    if (data.cpgCategory === "KNEE_LATERAL") return "KNEE.lateral";
    return "KNEE.pfp";
  }

  return null;
}

export function resolveMovementTestNameFromAssessment(data = {}) {
  const subtype = data.probableSubtype || data.subtype || null;
  if (subtype && TEST_MAP[subtype]?.name) return TEST_MAP[subtype].name;
  return "your first movement check";
}

export const NEGATIVE_TEST_MAP = {
  // LBP
  FLEXION_INTOLERANT: { name: "Toe Touch", video: "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/ToeTouchNegativeTestv1.0.mp4" },
  EXTENSION_INTOLERANT: { name: "Standing Lumbar Extension", video: "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/StandingLumbarExtensionROM-Negativev1.0.mp4" },
  LIMITED_LUMBAR_MOBILITY: { name: "Seated Trunk Rotation", video: "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/SeatedTrunkRotationvNegative1.0.mp4" },
  ROTATIONAL_INTOLERANT: { name: "Seated Trunk Rotation", video: "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/SeatedTrunkRotationv1.0.mp4" },
  NEUTRAL_SENSITIVE: null,
  // HIP
  ANTERIOR_CHAIN_MOBILITY_DEFICIT: { name: "Standing Hip Extension", video: PLACEHOLDER_VIDEO },
  POSTERIOR_CHAIN_MOBILITY_DEFICIT: { name: "Seated Single Knee to Chest", video: PLACEHOLDER_VIDEO },
  NEUROMUSCULAR_MOBILITY_DEFICIT: { name: "Toe Touch", video: PLACEHOLDER_VIDEO },
  ADDUCTOR_OVERLOAD_CONTROL_DEFICIT: { name: "Lateral Lunge", video: PLACEHOLDER_VIDEO },
  HIP_ABDUCTION_EXTERNAL_ROTATION_CONTROL_DEFICIT: { name: "Standing Hip Abduction", video: PLACEHOLDER_VIDEO },
  PELVIC_CONTROL_IMPAIRMENT: { name: "Squat", video: PLACEHOLDER_VIDEO },
  // THIGH
  QUADRICEPS_LOADING_IMPACT_INTOLERANCE: { name: "Sit to Stand", video: PLACEHOLDER_VIDEO },
  HAMSTRING_LOADING_LENGTHENING_DEFICIT: { name: "Sit to Stand", video: PLACEHOLDER_VIDEO },
  ITB_FRICTION_SYNDROME: { name: "Standing ITB Stretch - Toe Touch", video: PLACEHOLDER_VIDEO },
  // KNEE
  KNEE_VALGUS_COLLAPSE: { name: "Squat", video: PLACEHOLDER_VIDEO },
  PATELLOFEMORAL_PAIN_WITH_MALTRACKING: { name: "Seated Squat", video: PLACEHOLDER_VIDEO },
  LIMITED_KNEE_EXTENSION_FLEXION_MOBILITY: { name: "Seated Squat", video: PLACEHOLDER_VIDEO },
  TIBIAL_TRANSLATION_INSTABILITY: { name: "Seated Squat", video: PLACEHOLDER_VIDEO },
};

export const KNEE_NEGATIVE_TEST_OVERRIDES = {
  ITB_FRICTION_SYNDROME: { name: "Squat", video: PLACEHOLDER_VIDEO },
};

export function getNegativeTest(subtype, problemArea) {
  if (problemArea === 'KNEE' && KNEE_NEGATIVE_TEST_OVERRIDES[subtype]) {
    return KNEE_NEGATIVE_TEST_OVERRIDES[subtype];
  }
  return NEGATIVE_TEST_MAP[subtype] || null;
}

export const TEST_INTRO_VIDEOS = {
  // LBP
  "Standing Lumbar Extension": "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/IntroToAR-StandingLumbarExtension-v1.0.mp4",
  "Supine Double Knee to Chest": "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/IntroToAR-SupineDoubleKneeToChest-v1.0.mp4",
  "Seated Trunk Rotation": "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/IntroToAR-SeatedTrunkRotation-v1.0.mp4",
  "Side to Side Bend": "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/IntroToAR-SideToSideBend-v1.0.mp4",
  // HKT
  "Seated Hip Abduction": "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/GSA-SeatedHipAbduction.mp4",
  "Squat": "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/GSA-Squat-Neg.mp4",
  "Seated Squat": "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/GSA-SeatedSquat-Neg.mp4",
  "Sit to Stand": "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/GSA-SitToStand-Neg.mp4",
  "Seated Isometric Knee Extension": "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/GSA-SeatedIsometricKneeExtension.mp4",
  "Seated Hip Hinge": "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/GSA-SeatedHipHinge.mp4",
  "Standing Hip Abduction": "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/GSA-StandingHipAbduction-Neg.mp4",
  "Standing Hip Extension": "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/GSA-StandingHipExtension-Neg.mp4",
  "Standing Hip Flexor Stretch": "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/GSA-StandingHipFlexorStretch.mp4",
  "Seated Glute Stretch": "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/GSA-SeatedGluteStretch.mp4",
  "Lateral Lunge": "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/GSA-LateralLunge-Neg.mp4",
  "Standing ITB Stretch - Side Bend": "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/GSA-StandingITBStretch-SideBend.mp4",
  "Standing ITB Stretch - Toe Touch": "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/GSA-StandingITBStretch-ToeTouch-Neg.mp4",
  "Toe Touch": "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/ToeTouchNegativeTestv1.0.mp4",
  "Seated Single Knee to Chest": "https://virdiodev.s3.us-east-2.amazonaws.com/virtual_selfdemovideo/GSA-SeatedSingleKneeToChest-Neg.mp4",
};

// Plain-language descriptions of negative (Test 2) movements.
// Used by the feedback2 screen to fill {test2Description} in Myra's question.
export const TEST_PLAIN_DESCRIPTIONS = {
  "Toe Touch": "touch your toes",
  "Standing Lumbar Extension": "arch your back with your hands on your hips",
  "Seated Trunk Rotation": "sit down and twist your torso side to side",
  "Standing Hip Extension": "stand and lift one leg straight back behind you",
  "Seated Single Knee to Chest": "sit on a chair and lift one knee up toward your chest",
  "Lateral Lunge": "step out wide to one side and bend that knee",
  "Standing Hip Abduction": "stand and lift one leg straight out to the side",
  "Squat": "do a squat",
  "Sit to Stand": "stand up from a chair without using your hands",
  "Standing ITB Stretch - Toe Touch": "cross one leg in front of the other and reach for your toes",
  "Seated Squat": "lower yourself into a chair without using your hands",
};

export const SUBTYPE_TO_CPG_MAP = {
  LBP: {
    FLEXION_INTOLERANT: "LBP with Movement Coordination Impairments",
    EXTENSION_INTOLERANT: "LBP with Movement Coordination Impairments",
    ROTATIONAL_INTOLERANT: "LBP with Movement Coordination Impairments",
    NEUTRAL_SENSITIVE: "LBP with Movement Coordination Impairments",
    LIMITED_LUMBAR_MOBILITY: "LBP with Mobility Deficits",
  },
  HIP: {
    ANTERIOR_CHAIN_MOBILITY_DEFICIT: "Hip Pain with Mobility Deficits",
    POSTERIOR_CHAIN_MOBILITY_DEFICIT: "Hip Pain with Mobility Deficits",
    NEUROMUSCULAR_MOBILITY_DEFICIT: "Hip Pain with Mobility Deficits",
    ADDUCTOR_OVERLOAD_CONTROL_DEFICIT: "Hip Pain with Muscle Power Deficits",
    HIP_ABDUCTION_EXTERNAL_ROTATION_CONTROL_DEFICIT: "Hip Pain with Muscle Power Deficits",
    PELVIC_CONTROL_IMPAIRMENT: "Hip Pain with Impaired Motor Control",
  },
  THIGH: {
    QUADRICEPS_LOADING_IMPACT_INTOLERANCE: "Thigh Pain with Muscular Origin",
    ADDUCTOR_OVERLOAD_CONTROL_DEFICIT: "Thigh Pain with Muscular Origin",
    HAMSTRING_LOADING_LENGTHENING_DEFICIT: "Thigh Pain with Muscular Origin",
    ITB_FRICTION_SYNDROME: "Thigh Pain with Muscular Origin",
  },
  KNEE: {
    KNEE_VALGUS_COLLAPSE: "Patellofemoral Pain (PFP)",
    PATELLOFEMORAL_PAIN_WITH_MALTRACKING: "Patellofemoral Pain (PFP)",
    QUADRICEPS_LOADING_IMPACT_INTOLERANCE: "Knee Pain with Tendon Loading Deficits",
    LIMITED_KNEE_EXTENSION_FLEXION_MOBILITY: "Knee Pain with Mobility/Stability Deficits",
    TIBIAL_TRANSLATION_INSTABILITY: "Knee Pain with Mobility/Stability Deficits",
    ITB_FRICTION_SYNDROME: "Knee Pain with Lateral Symptoms",
    HAMSTRING_LOADING_LENGTHENING_DEFICIT: "Knee Pain with Posterior Symptoms",
  },
};

export const PRIMARY_ZONE_DEFAULTS = {
  LBP: 'Lower Back',
  HIP: 'Side Hip',
  THIGH: 'Back Thigh',
  KNEE: 'Front Knee',
};
export const HQ_ZONES = {
  LBP: ['Lower Back'],
  HIP: ['Side Hip', 'Front/Groin'],
  THIGH: ['Back Thigh', 'Front Thigh', 'Inner Thigh', 'Outer Thigh'],
  KNEE: ['Front Knee', 'Back Knee', 'Inner Knee', 'Outer Knee'],
};

// ════════════════════════════════════════════════════════════════
// SELF-REPORT, RPE, FEEL AFFECT, FEEDBACK 2, DURATION
// Same for all body areas
// ════════════════════════════════════════════════════════════════

export const SELF_REPORT_ROM = {
  heading: "How Did Your Movements Compare?",
  subheading: "Think about the first few reps you did and the last few reps. How did your movements change?",
  options: [
    { id: "rom_same", title: "Stayed the same", subtitle: "My last few reps and the first few were the same.", points: 10 },
    { id: "rom_smaller", title: "Got smaller", subtitle: "My movements became smaller as I kept going.", points: 0 },
    { id: "rom_bigger", title: "Got bigger", subtitle: "My movements became bigger as I kept going.", points: 5 },
  ]
};

export const SELF_REPORT_TEMPO = {
  heading: "Were you able to keep up with my counting for each rep?",
  subheading: "Compared to Myra's count, how would you describe your speed?",
  options: [
    { id: "tempo_kept_up", title: "Kept up", subtitle: "I matched Myra's speed or moved slightly faster.", points: 10, outcome: "CONTINUE" },
    { id: "tempo_slower", title: "Slowed down", subtitle: "I finished all the reps but moved slower.", points: 5, outcome: "CONTINUE" },
    { id: "tempo_not_finished", title: "Couldn't finish", subtitle: "I couldn't finish all the reps and had to stop.", points: 0, outcome: "HARD_STOP" },
  ]
};

export const RPE_OPTIONS = [
  { value: 1, label: "Easy" },
  { value: 3, label: "Kinda Easy" },
  { value: 5, label: "Just Right" },
  { value: 7, label: "Kinda Hard" },
  { value: 9, label: "Hard" },
];



export const FEEDBACK2_OPTIONS = [
  { id: "fb2-cant-try", value: "CANNOT_TRY", outcome: "CANNOT_TRY" },
  { id: "fb2-worse", value: "WORSE", outcome: "WORSE" },
  { id: "fb2-better", value: "BETTER", outcome: "BETTER" },
];

export const DURATION_OPTIONS = [
  { id: "duration-acute", value: "ACUTE", label: "Less than 6 weeks" },
  { id: "duration-subacute", value: "SUBACUTE", label: "6 weeks to 3 months" },
  { id: "duration-chronic", value: "CHRONIC", label: "More than 3 months" },
];


// ════════════════════════════════════════════════════════════════
// RPE & SELF-REPORT VOICE RESPONSE FUNCTIONS
// Stubs — need production speech text from VoiceService.
// Chunk 4 (RPE/self-report screens) will use these.
// ════════════════════════════════════════════════════════════════

// TODO: Populate with production Myra speech text per RPE value.
export function getRpeResponseText(value) {
  const responses = {
    1: "That was easy for you — good to know.",
    3: "A little bit of effort — noted.",
    5: "Right in the middle — that's useful information.",
    7: "That was pretty challenging — I'll keep that in mind.",
    9: "That was tough — thanks for pushing through it.",
  };
  return responses[value] || "";
}

// TODO: Populate with production Myra speech text per self-report selection.
// type: 'rom' | 'tempo', value: the option id
export function getSelfReportReplyText(type, value) {
  const responses = {
    rom: {
      rom_smaller: "Your range of motion decreased — that's useful to know.",
      rom_bigger: "Your range of motion increased — that's a positive sign.",
      rom_same: "Consistent movement — that's good information.",
    },
    tempo: {
      tempo_kept_up: "You kept up with the pace — great.",
      tempo_slower: "You slowed down a bit — that's completely okay.",
      tempo_not_finished: "You weren't able to finish — that's important for me to know.",
    },
  };
  return responses[type]?.[value] || "";
}


// ════════════════════════════════════════════════════════════════
// PERSONALIZE (Optional — grouped cards)
// ════════════════════════════════════════════════════════════════

export const PERSONALIZE_GROUPS = [
  {
    id: "personalize",
    myraIntro: "A few details about you so I can build the right plan. All of these are optional — if you skip them, I'll use conservative defaults.",
    fields: [
      { id: "age", type: "number", label: "Age", placeholder: "Your age", min: 18, max: 99 },
      { id: "weight", type: "number", label: "Weight (lbs)", placeholder: "Your weight", min: 50, max: 500 },
      { id: "heightFt", type: "number", label: "Height (ft)", placeholder: "Feet", min: 3, max: 8 },
      { id: "heightIn", type: "number", label: "Height (in)", placeholder: "Inches", min: 0, max: 11 },
      {
        id: "activity", type: "options", label: "How many days per week are you typically active?",
        options: [
          { id: "activity-sedentary", value: "SEDENTARY", label: "0" },
          { id: "activity-light", value: "LIGHTLY_ACTIVE", label: "1-2" },
          { id: "activity-active", value: "ACTIVE", label: "3-4" },
          { id: "activity-very-active", value: "VERY_ACTIVE", label: "5+" },
        ]
      },
      {
        id: "goals", type: "goals", label: "What are your goals?",
        options: [
          { id: "goal-reduce-pain", value: "reduce_pain", label: "Reduce Pain" },
          { id: "goal-less-stiff", value: "less_stiff", label: "Reduce Stiffness" },
          { id: "goal-improve-strength", value: "improve_strength", label: "Improve Strength" },
          { id: "goal-improve-flexibility", value: "improve_flexibility", label: "Improve Flexibility" },
          { id: "goal-daily-tasks", value: "daily_tasks", label: "Make Daily Tasks Easier" },
          { id: "goal-balance", value: "balance", label: "Improve Balance & Stability" },
          { id: "goal-picking-up", value: "picking_up", label: "Picking Up Things" },
          { id: "goal-sleep", value: "sleep", label: "Improve Sleep Quality" },
          { id: "goal-walking", value: "walking", label: "Improve Walking & Endurance" },
          { id: "goal-lifting", value: "lifting", label: "Make Bending & Lifting Easier" },
          { id: "goal-posture", value: "posture", label: "Improve Sitting & Standing Posture" },
          { id: "goal-rotational-sports", value: "rotational_sports", label: "Return to Sports (Golf, Tennis, etc.)" },
          { id: "goal-overhead-sports", value: "overhead_sports", label: "Return to Sports (Basketball, Swimming, etc.)" },
          { id: "goal-running", value: "running", label: "Running, Cycling, etc." },
          { id: "goal-fitness", value: "fitness", label: "Fitness: Gym, CrossFit, etc." },
        ]
      },
      {
        id: "duration", type: "options", label: "How long have you been experiencing these symptoms?",
        options: [
          { id: "duration-acute", value: "ACUTE", label: "Less than 6 weeks" },
          { id: "duration-subacute", value: "SUBACUTE", label: "6 weeks to 3 months" },
          { id: "duration-chronic", value: "CHRONIC", label: "More than 3 months" },
        ]
      },
      {
        id: "balance", type: "options", label: "How would you describe your balance?",
        options: [
          { id: "balance-steady", value: "steady", label: "Steady" },
          { id: "balance-mixed", value: "unsteady", label: "Steady & Unsteady" },
        ]
      },
      // {
      //   id: "floorCapability", type: "options", label: "Are you comfortable getting up and down from the floor?",
      //   options: [
      //     { id: "capability-floor-yes", value: "yes", label: "YES" },
      //     { id: "capability-floor-no", value: "no", label: "NO" },
      //   ]
      // }
    ]
  }
];

export const PERSONALIZE_SKIP_MESSAGES = {
  basics: "I'll use conservative settings for your plan. Providing your age, weight, and height later will help me make it more accurate.",
  capacity: "Without knowing your activity level and floor capability, I'll start you at a gentler intensity to be safe.",
  preferences: "I'll set you up with a standard schedule — you can adjust this anytime.",
};


// ════════════════════════════════════════════════════════════════
// STEP LABELS & SUBTYPE DISPLAY NAMES
// ════════════════════════════════════════════════════════════════

export const STEP_LABELS = {
  intro: "Getting Started",
  problem_area: "Problem Area",
  pain_location: "Pinpoint Your Pain",
  safety: "Safety Check",
  safety_followup: "Safety Check",
  cpg: "Pain Character",
  subtype_q1: "Pain Pattern",
  q2: "Pain Pattern",
  pre_nprs: "Pain Level",
  demo_video_1: "Movement Check 1",
  demo_video_2: "Movement Check 2",
  camera: "Camera Setup",
  movement_1: "Movement Check 1",
  movement_2: "Movement Check 2",
  self_report_movement_1: "Movement Check 1",
  self_report_movement_2: "Movement Check 2",
  self_report_rom: "SELF-REPORT REP EXTENSION",
  self_report_tempo: "SELF-REPORT REP SPEED",
  rpe: "How Challenging",
  feel_affect: "Symptom Response",
  feedback2: "Movement Comparison",
  personalize: "Personalize Your Plan",
  recovery_score: "Recovery Compass",
  plan: "Your Recovery Plan",
  hard_stop: "Safety Recommendation",
};

export const SUBTYPE_DISPLAY_NAMES = {
  // LBP
  FLEXION_INTOLERANT: "Flexion-Sensitive",
  EXTENSION_INTOLERANT: "Extension-Sensitive",
  NEUTRAL_SENSITIVE: "Neutral Zone Sensitivity",
  LIMITED_LUMBAR_MOBILITY: "Limited Lumbar Mobility",
  ROTATIONAL_INTOLERANT: "Rotation-Sensitive",
  // HIP
  ANTERIOR_CHAIN_MOBILITY_DEFICIT: "Anterior Chain Mobility Deficit",
  POSTERIOR_CHAIN_MOBILITY_DEFICIT: "Posterior Chain Mobility Deficit",
  NEUROMUSCULAR_MOBILITY_DEFICIT: "Neuromuscular Mobility Deficit",
  ADDUCTOR_OVERLOAD_CONTROL_DEFICIT: "Adductor Overload/Control Deficit",
  HIP_ABDUCTION_EXTERNAL_ROTATION_CONTROL_DEFICIT: "Hip Abduction/External Rotation Control Deficit",
  PELVIC_CONTROL_IMPAIRMENT: "Pelvic Control Impairment",
  // THIGH
  QUADRICEPS_LOADING_IMPACT_INTOLERANCE: "Quadriceps Loading/Impact Intolerance",
  HAMSTRING_LOADING_LENGTHENING_DEFICIT: "Hamstring Loading/Lengthening Deficit",
  ITB_FRICTION_SYNDROME: "ITB Friction Syndrome",
  // KNEE
  KNEE_VALGUS_COLLAPSE: "Knee Valgus Collapse",
  PATELLOFEMORAL_PAIN_WITH_MALTRACKING: "Patellofemoral Pain with Maltracking",
  LIMITED_KNEE_EXTENSION_FLEXION_MOBILITY: "Limited Knee Extension/Flexion Mobility",
  TIBIAL_TRANSLATION_INSTABILITY: "Tibial Translation (Instability)",
};


// ════════════════════════════════════════════════════════════════
// MESSAGING — Diagnosis, Plan Focus, Readiness Tiers
// ════════════════════════════════════════════════════════════════

export const MESSAGING = {
  diagnosis: {
    // LBP
    FLEXION_INTOLERANT: {
      headline: "Your Back Dislikes Bending Forward",
      clinicalTerm: "Flexion Intolerance",
      implications: "Activities that involve rounding your lower back, like slouching or tying your shoes, are likely to increase your discomfort.",
      relief: "You May Find That Standing Or Arching Your Back Provides Relief",
    },
    EXTENSION_INTOLERANT: {
      headline: "Your Back Dislikes Arching or Extended Standing",
      clinicalTerm: "Extension Intolerance",
      implications: "You might find that prolonged standing or walking is uncomfortable, and that sitting or slouching provides relief.",
      relief: "You May Find That Sitting Or Slouching Provides Relief",
    },
    LIMITED_LUMBAR_MOBILITY: {
      headline: "Your Back Pain May Be Caused by Stiffness",
      clinicalTerm: "Limited Lumbar Mobility",
      implications: "Because your lower back isn't moving as freely as it could, you might find that activities like putting on your shoes or getting out of a car feel stiff and difficult.",
      relief: "Gentle Movement In All Directions May Provide Relief",
    },
    NEUTRAL_SENSITIVE: {
      headline: "Your Back Seems to Want More Support",
      clinicalTerm: "Movement Coordination Impairments",
      implications: 'You might notice that your back feels weak, unstable, or like it might "give out."',
      relief: "Changing Positions Frequently May Be Your Best Source Of Relief Right Now",
    },
    ROTATIONAL_INTOLERANT: {
      headline: "Your Back Dislikes Twisting",
      clinicalTerm: "Rotational Intolerance",
      implications: "You might find that movements involving twisting, turning, or reaching across your body increase your discomfort.",
      relief: "Minimizing Twisting Motions May Provide Relief",
    },
    // HIGH_FUNCTIONING: triggered when backend returns complexityLevel === 5
    // Cannot be determined client-side — requires Recovery Compass Score API.
    HIGH_FUNCTIONING: {
      headline: "Your Back Is Ready to Level Up",
      clinicalTerm: "High Functioning / Low Irritability",
      implications: "You've shown strong control and minimal symptoms during the assessment, so you are well-positioned to progress beyond basic exercises and build a stronger, more durable back.",
      relief: "You May Find That Standing Or Arching Your Back Provides Relief",
    },
    // HIP
    ANTERIOR_CHAIN_MOBILITY_DEFICIT: {
      headline: "Your Hip Pain May Be Related to Tight Hip Flexors",
      clinicalTerm: "Anterior Chain Mobility Deficit",
      implications: "You might find that extending your leg behind you, standing up after prolonged sitting, or walking uphill increases your discomfort.",
      relief: "Hip Flexor Stretching May Provide Relief",
    },
    POSTERIOR_CHAIN_MOBILITY_DEFICIT: {
      headline: "Your Hip Pain May Be Related to Tight Posterior Muscles",
      clinicalTerm: "Posterior Chain Mobility Deficit",
      implications: "You might find that bringing your knee toward your chest, sitting for long periods, or certain rotational movements increase your discomfort.",
      relief: "Glute and Hip Mobility Work May Provide Relief",
    },
    NEUROMUSCULAR_MOBILITY_DEFICIT: {
      headline: "Your Hip Pain May Have a Neural Component",
      clinicalTerm: "Neuromuscular Mobility Deficit",
      implications: "You might notice a deep, specific pain in your buttock that sometimes travels down your leg, especially with certain sitting positions.",
      relief: "Gentle Neural Mobilization May Provide Relief",
    },
    ADDUCTOR_OVERLOAD_CONTROL_DEFICIT: {
      headline: "Your Pain May Be Related to Inner Thigh Muscles",
      clinicalTerm: "Adductor Overload/Control Deficit",
      implications: "You might find that moving your legs apart, side-stepping, or activities that stress your inner thigh increase your discomfort.",
      relief: "Inner Thigh Strengthening May Provide Relief",
    },
    HIP_ABDUCTION_EXTERNAL_ROTATION_CONTROL_DEFICIT: {
      headline: "Your Hip May Need Better Side Support",
      clinicalTerm: "Hip Abduction/External Rotation Control Deficit",
      implications: "You might notice your hip drops when walking, or you feel unsteady when standing on one leg or climbing stairs.",
      relief: "Hip Abductor Strengthening May Provide Relief",
    },
    PELVIC_CONTROL_IMPAIRMENT: {
      headline: "Your Hip Needs Better Pelvic Control",
      clinicalTerm: "Pelvic Control Impairment",
      implications: "You might notice a pinching, clicking, or catching feeling in the front of your hip during certain movements, or feel like your pelvis isn't stable.",
      relief: "Pelvic Stability Exercises May Provide Relief",
    },
    // THIGH
    QUADRICEPS_LOADING_IMPACT_INTOLERANCE: {
      headline: "Your Thigh Pain May Be Related to Quadriceps Loading",
      clinicalTerm: "Quadriceps Loading/Impact Intolerance",
      implications: "You might find that activities like running, jumping, going down stairs, or kicking increase your front thigh discomfort.",
      relief: "Progressive Quadriceps Loading May Provide Relief",
    },
    HAMSTRING_LOADING_LENGTHENING_DEFICIT: {
      headline: "Your Thigh Pain May Be Related to Hamstring or Posterior Chain",
      clinicalTerm: "Hamstring Loading/Lengthening Deficit",
      implications: "You might find that bending forward, stretching, quick movements, or prolonged sitting increase your thigh discomfort.",
      relief: "Progressive Hamstring Work May Provide Relief",
    },
    ITB_FRICTION_SYNDROME: {
      headline: "Your Pain May Be Related to IT Band Tightness",
      clinicalTerm: "ITB Friction Syndrome",
      implications: "You might notice pain on the outer side of your thigh or knee, especially with repetitive activities like running or cycling.",
      relief: "IT Band Stretching and Hip Strengthening May Provide Relief",
    },
    // KNEE
    KNEE_VALGUS_COLLAPSE: {
      headline: "Your Knee Pain May Be Related to Inward Knee Motion",
      clinicalTerm: "Knee Valgus Collapse",
      implications: "You might notice your knee diving inward during squats, stairs, or landing from jumps.",
      relief: "Hip Strengthening to Control Knee Position May Provide Relief",
    },
    PATELLOFEMORAL_PAIN_WITH_MALTRACKING: {
      headline: "Your Knee Pain May Be Related to Kneecap Tracking",
      clinicalTerm: "Patellofemoral Pain with Maltracking",
      implications: "You might notice grinding, clicking, or pain under your kneecap, especially after prolonged sitting.",
      relief: "Quadriceps Control and Patellar Tracking Exercises May Provide Relief",
    },
    LIMITED_KNEE_EXTENSION_FLEXION_MOBILITY: {
      headline: "Your Knee May Need Better Mobility",
      clinicalTerm: "Limited Knee Extension/Flexion Mobility",
      implications: "You might find it difficult to fully straighten or bend your knee, with stiffness throughout the range.",
      relief: "Gentle Range of Motion Exercises May Provide Relief",
    },
    TIBIAL_TRANSLATION_INSTABILITY: {
      headline: "Your Knee May Feel Unstable",
      clinicalTerm: "Tibial Translation (Instability)",
      implications: "You might feel like your knee could buckle, shift, or give way during activities.",
      relief: "Controlled Strengthening to Improve Stability May Provide Relief",
    },
  },
  readinessTiers: {
    READY_TO_GO: {
      headline: "Ready to Go",
      description: "Your history and health factors show you're ready for a standard starting intensity.",
    },
    CAUTIOUS_START: {
      headline: "A Cautious Start",
      description: "We've slightly adjusted the intensity of your plan to ensure your body adapts well as you get started.",
    },
    GENTLE_APPROACH: {
      headline: "A Gentle Approach",
      description: "We've adjusted your plan to begin with a gentler intensity, giving your body extra time to respond and build momentum safely.",
    },
    STARTING_WITH_CARE: {
      headline: "Starting with Care",
      description: "To ensure the safest start, your plan begins with a very gentle intensity, focused on building a solid foundation.",
    },
  },

  planFocus: {
    // LBP
    FLEXION_INTOLERANT: "Reduce Sensitivity to Bending",
    EXTENSION_INTOLERANT: "Relieve Pressure from Arching",
    LIMITED_LUMBAR_MOBILITY: "Improve Flexibility",
    NEUTRAL_SENSITIVE: "Build Core Support",
    ROTATIONAL_INTOLERANT: "Reduce Sensitivity to Twisting",
    HIGH_FUNCTIONING: "Build Strength & Durability",
    // HIP
    ANTERIOR_CHAIN_MOBILITY_DEFICIT: "Improve Hip Flexor Flexibility",
    POSTERIOR_CHAIN_MOBILITY_DEFICIT: "Improve Hip Mobility",
    NEUROMUSCULAR_MOBILITY_DEFICIT: "Address Neural Tension",
    ADDUCTOR_OVERLOAD_CONTROL_DEFICIT: "Strengthen Inner Thigh Control",
    HIP_ABDUCTION_EXTERNAL_ROTATION_CONTROL_DEFICIT: "Strengthen Hip Abductors",
    PELVIC_CONTROL_IMPAIRMENT: "Improve Pelvic Stability",
    // THIGH
    QUADRICEPS_LOADING_IMPACT_INTOLERANCE: "Build Quadriceps Tolerance",
    HAMSTRING_LOADING_LENGTHENING_DEFICIT: "Improve Posterior Chain Flexibility",
    ITB_FRICTION_SYNDROME: "Release IT Band Tension",
    // KNEE
    KNEE_VALGUS_COLLAPSE: "Control Knee Alignment",
    PATELLOFEMORAL_PAIN_WITH_MALTRACKING: "Improve Kneecap Tracking",
    LIMITED_KNEE_EXTENSION_FLEXION_MOBILITY: "Restore Knee Range of Motion",
    TIBIAL_TRANSLATION_INSTABILITY: "Build Knee Stability",
  },
};

export const READINESS_TIERS = {
  READY_TO_GO: { headline: "Ready to Go", description: "Your history and health factors show you're ready for a standard starting intensity." },
  CAUTIOUS_START: { headline: "A Cautious Start", description: "We've slightly adjusted the intensity of your plan to ensure your body adapts well." },
  GENTLE_APPROACH: { headline: "A Gentle Approach", description: "We've adjusted your plan to begin with a gentler intensity, giving your body extra time to respond." },
  STARTING_WITH_CARE: { headline: "Starting with Care", description: "Your plan begins with a very gentle intensity, focused on building a solid foundation." },
};


// ════════════════════════════════════════════════════════════════
// EXIT HANDLER CONFIG & MESSAGES
// ════════════════════════════════════════════════════════════════

export const EXIT_CONFIGS = {
  gsa: {
    heading: "Having Trouble or Thinking About Leaving?",
    subheading: "Let us know if you need help or want to exit — we're here to support you.",
    tiles: [
      { reason: 'confused', title: "I'm not sure how to answer", desc: "Not sure what fits your situation? Myra can help with any questions you have." },
      { reason: 'technical', title: "Are you having technical difficulties?", desc: "If something isn't working, Myra can help troubleshoot the issue." },
      { reason: 'leave', title: "I want to leave the assessment", desc: "If you decide to leave, we'd love to hear how we can improve." },
    ]
  },
  personalize: {
    heading: "We Can Help or Want to Exit?",
    subheading: "This information helps us create your personalized recovery plan.",
    tiles: [
      { reason: 'why_info', title: "Why do you need this information?", desc: "Curious why we're asking for age, weight, or other details? Myra can explain everything." },
      { reason: 'confused', title: "I'm not sure how to answer", desc: "Not sure what to put? Myra can guide you through any question or field." },
      { reason: 'technical', title: "Something isn't working", desc: "If the screen or buttons aren't responding, Myra can help troubleshoot the issue." },
      { reason: 'leave', title: "I want to leave the assessment", desc: "If you decide to stop, we'd love to hear how we can improve your experience." },
    ]
  },
  movement_test: {
    heading: "Tracking Trouble or Want to Exit?",
    subheading: "Let us know if you need help or want to exit — we're here to support you.",
    tiles: [
      { reason: 'tracking', title: "Tracking isn't working correctly", desc: "Having trouble with the camera or body tracking? Myra can help troubleshoot." },
      { reason: 'confused', title: "I'm not sure how to answer", desc: "Not sure what fits your situation? Myra can help with any questions you have." },
      { reason: 'technical', title: "Something isn't working", desc: "If the screen or buttons aren't responding, Myra can help troubleshoot the issue." },
      { reason: 'leave', title: "I want to leave the assessment", desc: "If you decide to stop, we'd love to hear how we can improve your experience." },
    ]
  }
};

export const EXIT_MYRA_MESSAGES = {
  confused: "No worries — what part is unclear? I'm happy to walk you through it.",
  technical: "Sorry about that. Can you tell me what's happening — is the screen frozen, or is something not responding?",
  why_info: "Great question. Your age, weight, and other details help me choose exercises at the right intensity and make sure they're safe. What specifically are you wondering about?",
  tracking: "I see you're having trouble with the tracking. Are the targets not showing up, or is the camera not picking up your body?",
};

export function getExitContext(step) {
  const s = step || '';
  if (s.includes('personalize')) return 'personalize';
  if (s.includes('movement') || s.includes('self_report') || s.includes('demo_video') || s.includes('camera')) return 'movement_test';
  return 'gsa';
}


// ════════════════════════════════════════════════════════════════
// INTENT DETECTION — Intro screen pre-selection
// ════════════════════════════════════════════════════════════════

export const AREA_MAP = { 'lower back': 'LBP', 'back': 'LBP', 'hip': 'HIP', 'thigh': 'THIGH', 'knee': 'KNEE', 'leg': 'KNEE' };

export function detectArea(text) {
  const lower = text.toLowerCase();
  for (const [kw, id] of Object.entries(AREA_MAP)) {
    if (lower.includes(kw)) return id;
  }
  return null;
}

export const TRIGGER_KEYWORDS = {
  a: ['bend', 'sit', 'slouch', 'forward', 'sitting'],
  b: ['stand', 'walk', 'standing', 'walking'],
  e: ['twist', 'turn', 'rotation', 'car'],
  c: ['position', 'still', 'one position', 'stay'],
};

export const DURATION_KEYWORDS = {
  ACUTE: ['few days', 'last week', 'just started', 'recent', 'few weeks'],
  CHRONIC: ['months', 'years', 'long time', 'forever', 'chronic'],
};


// ════════════════════════════════════════════════════════════════
// PLAN Q&A ANSWERS — canned responses for plan screen quick-ask
// ════════════════════════════════════════════════════════════════

export const PLAN_QA_ANSWERS = {
  why: "Each exercise was chosen based on your pain pattern, movement results, and subtype classification. They target the specific areas that need strengthening or mobility work for your recovery.",
  often: "Your plan is designed for 3 sessions per week. Each session takes about 15–20 minutes. Consistency matters more than intensity — even 2 sessions is better than none.",
  hurts: "Mild discomfort during exercises can be normal, but sharp or increasing pain is not. If an exercise causes pain above a 4 out of 10 or gets worse as you go, stop and let me know. I can swap it for an alternative.",
};


// ════════════════════════════════════════════════════════════════
// DUMMY RECOVERY PLANS — Per Body Area (prototype/testing only)
// Production gets plans from the backend.
// ════════════════════════════════════════════════════════════════

export const DUMMY_PLANS = {
  LBP: {
    score: 42,
    readinessModifier: 85,
    estimatedTime: "15-20",
    exercises: [
      { name: "Cat-Cow Stretch", sets: 2, reps: 10, hold: null, rationale: "Gentle spinal mobility helps reduce stiffness and promote fluid movement through your lower back." },
      { name: "Pelvic Tilts", sets: 2, reps: 12, hold: null, rationale: "Activates your deep core stabilizers, building a foundation of support for your lower back." },
      { name: "Bird-Dog", sets: 2, reps: 8, hold: 5, rationale: "Trains coordinated core control in a low-load position, improving stability without stressing your back.", performance_side: "Left" },
      { name: "Bird-Dog", sets: 2, reps: 8, hold: 5, rationale: "Trains coordinated core control in a low-load position, improving stability without stressing your back.", performance_side: "Right" },
      { name: "Glute Bridge", sets: 2, reps: 10, hold: null, rationale: "Strengthens your glutes and posterior chain, reducing load on your lower back during daily activities." },
      { name: "Supine Knee-to-Chest Stretch", sets: 1, reps: 4, hold: 15, rationale: "Gently stretches your lower back and hip flexors, helping relieve tension." },
    ],
  },
  HIP: {
    score: 45,
    readinessModifier: 85,
    estimatedTime: "15-20",
    exercises: [
      { name: "Seated Hip Circles", sets: 2, reps: 10, hold: null, rationale: "Promotes hip joint mobility and synovial fluid circulation to reduce stiffness." },
      { name: "Standing Hip Flexor Stretch", sets: 2, reps: 4, hold: 20, rationale: "Lengthens the hip flexors that tighten from prolonged sitting.", performance_side: "Left" },
      { name: "Standing Hip Flexor Stretch", sets: 2, reps: 4, hold: 20, rationale: "Lengthens the hip flexors that tighten from prolonged sitting.", performance_side: "Right" },
      { name: "Clamshell", sets: 2, reps: 12, hold: null, rationale: "Strengthens hip external rotators and abductors to improve pelvic stability.", performance_side: "Left" },
      { name: "Clamshell", sets: 2, reps: 12, hold: null, rationale: "Strengthens hip external rotators and abductors to improve pelvic stability.", performance_side: "Right" },
      { name: "Glute Bridge", sets: 2, reps: 10, hold: null, rationale: "Strengthens your glutes to better support hip joint mechanics." },
    ],
  },
  THIGH: {
    score: 48,
    readinessModifier: 85,
    estimatedTime: "15-20",
    exercises: [
      { name: "Seated Quad Set", sets: 2, reps: 10, hold: 5, rationale: "Activates your quadriceps in a low-load position to build foundational thigh strength." },
      { name: "Standing Hamstring Curl", sets: 2, reps: 10, hold: null, rationale: "Strengthens the hamstrings to balance forces across the thigh.", performance_side: "Left" },
      { name: "Standing Hamstring Curl", sets: 2, reps: 10, hold: null, rationale: "Strengthens the hamstrings to balance forces across the thigh.", performance_side: "Right" },
      { name: "Standing IT Band Stretch", sets: 2, reps: 4, hold: 20, rationale: "Reduces tension along the outer thigh to alleviate friction at the knee.", performance_side: "Left" },
      { name: "Standing IT Band Stretch", sets: 2, reps: 4, hold: 20, rationale: "Reduces tension along the outer thigh to alleviate friction at the knee.", performance_side: "Right" },
      { name: "Seated Hip Hinge", sets: 2, reps: 10, hold: null, rationale: "Trains proper hip hinge mechanics to reduce compensatory thigh loading." },
    ],
  },
  KNEE: {
    score: 40,
    readinessModifier: 85,
    estimatedTime: "15-20",
    exercises: [
      { name: "Seated Isometric Quad Hold", sets: 2, reps: 8, hold: 10, rationale: "Builds quadriceps strength without stressing the knee joint through range of motion." },
      { name: "Seated Knee Extension", sets: 2, reps: 10, hold: null, rationale: "Strengthens the quadriceps to improve patellar tracking and knee stability." },
      { name: "Standing Calf Raise", sets: 2, reps: 12, hold: null, rationale: "Strengthens the lower leg muscles that support knee stability during walking and stairs." },
      { name: "Seated Hip Abduction", sets: 2, reps: 10, hold: null, rationale: "Strengthens the hip abductors to prevent knee valgus collapse during functional movements." },
      { name: "Wall Sit", sets: 2, reps: 4, hold: 15, rationale: "Builds isometric quadriceps endurance to support knee function during daily activities." },
      { name: "Standing Hamstring Curl", sets: 2, reps: 10, hold: null, rationale: "Balances quadriceps-hamstring strength ratio for overall knee joint stability.", performance_side: "Left" },
    ],
  },
};

export function getDummyPlan(problemArea) {
  return DUMMY_PLANS[problemArea] || DUMMY_PLANS.LBP;
}

// nprs:



export const RPE_OPTIONS2 = [
  { value: 1, label: 'Easy', emoji: '😌', color: '#8ec5ff' },
  { value: 3, label: 'Kinda Easy', emoji: '🙂', color: '#6aa8e8' },
  { value: 5, label: 'Just Right', emoji: '😐', color: '#4d80c4' },
  { value: 7, label: 'Kinda Hard', emoji: '😬', color: '#3d54a0' },
  { value: 9, label: 'Hard', emoji: '😤', color: '#432dd7' }
];
export const FEEL_AFFECT_OPTIONS = [
  { id: 'symptom-improved', label: 'Felt Better', value: 'IMPROVED' },
  { id: 'symptom-tolerable', label: 'Felt Same', value: 'TOLERABLE' },
  { id: 'symptom-worsened', label: 'Felt Worse', value: 'WORSENED' }
];
